import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';

const messages = {
  idle: 'Press Play to listen.', loading: 'Loading question audio…', playing: 'Question audio is playing.',
  ended: 'Audio finished. You can replay it.', interrupted: 'Audio stopped. Press Replay to listen again.',
  error: 'Audio could not be played. Try again.',
  blocked: 'Question audio is unavailable. Ask your teacher for help.',
};

export default function ListeningControl({ playback, disabled, previewScoring = false, scored = false, staffReview = false }) {
  const { status, play } = playback;
  const busy = status === 'loading' || status === 'playing';
  const replay = status === 'ended' || status === 'interrupted';
  return <Box sx={{ textAlign: 'center', mb: 1.5 }}>
    <Button onClick={() => { if (!busy && !disabled && status !== 'blocked') play(); }}
      disabled={disabled || status === 'blocked'} aria-disabled={disabled || busy || status === 'blocked'}
      startIcon={replay ? <ReplayRoundedIcon /> : <PlayArrowRoundedIcon />}
      sx={{ minWidth: { xs: 160, md: 240 }, minHeight: { xs: 48, md: 64 },
        fontSize: { xs: 15, md: 22 }, bgcolor: '#ede9fe', color: '#37306f', fontWeight: 900,
        border: '2px solid #6d28d9', borderRadius: 3,
        '&:hover': { bgcolor: '#ddd6fe' },
        '&.Mui-focusVisible': { outline: '3px solid #37306f', outlineOffset: 3 } }}>
      {status === 'loading' ? 'Loading audio…' : status === 'playing' ? 'Playing audio…'
        : status === 'error' ? 'Retry audio' : replay ? 'Replay question audio' : 'Play question audio'}
    </Button>
    <Typography role="status" aria-live="polite" aria-atomic="true"
      sx={{ color: '#37306f', fontWeight: 700, mt: 1, fontSize: { xs: 16, md: 20 } }}>
      {scored ? 'Your answer was saved.' : messages[status]}
    </Typography>
    {!scored && <Typography sx={{ color: '#37306f', fontSize: { xs: 14, md: 18 }, mt: 0.5 }}>
      {staffReview
        ? (previewScoring ? 'Staff preview. Listen, then choose your answer.' : 'Staff review. Student use is off.')
        : previewScoring ? 'Practice preview. Listen, then choose your answer.' : 'Listening is awaiting approval. Answers are unavailable.'}
    </Typography>}
  </Box>;
}
